(function (canopyCore, angular) {
	"use strict";

	canopyCore.filter("typeof", function () {
		return function(obj) {
			return typeof obj;
		};
	});

})(canopyCore, angular);